import {
    GET_ALL_PAYOUT_LOGS,
    GET_ALL_PAYOUT_LOGS_ZB,
    GET_ALL_TRANS_LOGS,
    RESPONSE_STATUS,
    CLEAR_RESPONSE,
    GET_ALL_TRANS_LOGS_ZB,
} from './sellerPayoutTypes'

export default (state, action) => {
    switch (action.type) {
        case RESPONSE_STATUS:
            return {
                ...state,
                responseStatus: action.payload,
            }
        case GET_ALL_PAYOUT_LOGS:
            return {
                ...state,
                all_payment: action.payload,
            }
        case GET_ALL_PAYOUT_LOGS_ZB:
            return {
                ...state,
                all_payment_zb: action.payload,
            }
        case GET_ALL_TRANS_LOGS:
            return {
                ...state,
                all_trans: action.payload,
            }
        case GET_ALL_TRANS_LOGS_ZB:
            return {
                ...state,
                all_trans_zb: action.payload,
            }
        case CLEAR_RESPONSE:
            return {
                ...state,
                responseStatus: '',
            }
        default:
            return state
    }
}
